var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-chips",on:{"click":function($event){return _vm.$emit('delete', _vm.id)}}},[_c('icon-delete-chip',{staticClass:"mr-1"}),_vm._v(" "+_vm._s(_vm.label)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }